import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ServiceNumberModel} from '@app/models/service-number.model';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtConfigurationService} from '@app/services/gt-configuration.service';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {GtNotificationService} from '@app/services/gt-notification.service';
import {BuilderFactory} from '@app/shared/utils/builder.factory';
import {GtServiceNumbersUtil} from '@app/shared/utils/gt-service-numbers.util';
import {TranslateService} from '@ngx-translate/core';
import {of, Subject} from 'rxjs';
import {catchError, map, switchMap, takeUntil, tap} from 'rxjs/operators';

@Component({
  selector: 'gt-display-number-selector',
  templateUrl: './display-number-selector.component.html',
  styleUrls: ['./display-number-selector.component.scss']
})
export class DisplayNumberSelectorComponent implements OnInit, OnDestroy {
  @Input() oname: string;
  @Input() login: string;
  @Input() canEdit = true;
  @Input() fullNumber: string;

  displayNumbers: Array<ServiceNumberModel> = [];
  displayNumber: ServiceNumberModel;

  @Input() placeholder = 'display_number.title';
  @Output() displayNumberSelected = new EventEmitter<string>();

  private destroyed = new Subject<void>();

  constructor(
    private authenticationService: GtAuthenticationService,
    private configurationService: GtConfigurationService,
    private notificationService: GtNotificationService,
    private directoryService: GtDirectoryService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.oname = this.oname || this.authenticationService.oname;
    this.login = this.login || this.authenticationService.login;
    this.fullNumber = this.fullNumber || this.authenticationService.userData.fullNumber;

    this.translateService
      .get('display_number.my_number')
      .pipe(
        map(myNumberString => {
          return BuilderFactory.createBuilder(ServiceNumberModel).phoneNumber(this.fullNumber).name(myNumberString).build();
        }),
        switchMap(myNumber =>
          this.directoryService.getServiceNumberModels(this.oname, false).pipe(
            map(models => models.filter(snd => GtServiceNumbersUtil.visibleInDisplayNumbers(snd))),
            tap(allowedDisplayNumbers => (this.displayNumbers = [].concat(myNumber, allowedDisplayNumbers))),
            switchMap(_ => this.configurationService.getDisplayNumber(this.oname, this.login)),
            map(displayNumber => this.displayNumbers.find(sn => sn.phoneNumber === displayNumber) || this.displayNumbers[0]),
            catchError(err => {
              return of(myNumber);
            }),
            tap(displayNumber => {
              this.displayNumber = displayNumber;
              this.displayNumberSelected.emit(displayNumber.phoneNumber);
            }),
            takeUntil(this.destroyed)
          )
        )
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  displayNumberChanged(displayNumber: ServiceNumberModel) {
    if (displayNumber && displayNumber.phoneNumber && displayNumber.phoneNumber.length) {
      this.configurationService.setDisplayNumber(this.oname, this.login, displayNumber.phoneNumber).subscribe(() => {
        this.displayNumberSelected.emit(displayNumber.phoneNumber);
      });
    }
  }
}
